export default __webpack_public_path__ + "static/media/news7.708770ac.jpg";